/*
  INSERT INTO _41rs (_dmn, _key, _fst, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 1, 1, '1', 'エントリー・抽選・直接予約', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  UPDATE _41rs SET _vsn=1, _ltt=1;

  INSERT INTO _411s (_dmn, _key, _fst, _411_41r1k, _411_40r1k, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 1, 1, 1, 2030, -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _411s (_dmn, _key, _fst, _411_41r1k, _411_40r1k, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 2, 2, 1, 2040, -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _411s (_dmn, _key, _fst, _411_41r1k, _411_40r1k, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 3, 3, 1, 2050, -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  UPDATE _411s SET _vsn=1, _ltt=1;

*/

export const _42z = {
  _42r: { // 権限割当情報
    v0: {
      itlz: {
        _42r_31r1f: -1, 
        _42r_10r1k: -1,
      },
      fldz: {
        _42r_31r1f: {
          pfx: '所属部門',
        },
        _42r_10r1k: {
          pfx: '利用者',
        },
      },
    },
  },
  _421: { // 担当別権限割当情報
    v0: {
      itlz: {
        _421_31r1f: -1,
        _421_42r1k: -1,
        _421_41r1f: -1,
      },
      fldz: {
        _421_31r1f: {
          pfx: '所属部門',
        },
        _421_42r1k: {
          pfx: '権限割当',
        },
        _421_41r1f: {
          pfx: '権限分類',
        },
      },
    },
  },
};
